module.exports = __webpack_public_path__ + "img/googlePage.8d492ba3.jpg";